import http from "../../../core/utils/apis/api";

const getObjectivesAndUsers = async (trainingId) => {
  try {
    const response = await http({
      method: "GET",
      url: `/objectiveEvaluationScores/objective/course/${trainingId}`,
      params: {
        objectiveType: 'technical',
      },
    });
    return response;
  } catch (e) {
    throw e;
  }
};

const submitObjectivesEvaluationsScores = async (data) => {
  try {
    const response = await http({
      method: "POST",
      url: `/objectiveEvaluationScores/upsert`,
      data: data
    });
    return response;
  } catch (e) {
    throw e;
  }
};

const technicalObjectivesService = {
    getObjectivesAndUsers,
    submitObjectivesEvaluationsScores,
};

export default technicalObjectivesService;
